module.exports = __webpack_public_path__ + "static/media/nimes_maisoncarree_tn.48330518.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Provence/nimes_maisoncarree_tn.jpg
// module id = 732
// module chunks = 0